import { render } from "./EditPlatFormShop.vue?vue&type=template&id=efda3546&scoped=true"
import script from "./EditPlatFormShop.vue?vue&type=script&lang=js"
export * from "./EditPlatFormShop.vue?vue&type=script&lang=js"

import "./EditPlatFormShop.vue?vue&type=style&index=0&id=efda3546&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efda3546"]])

export default __exports__